import { createApp } from 'vue'
import App from '@/App'
// 添加全局样式
import "@/assets/styles/index.scss"

// 引入 ant-design
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

// 引入Vant组件样式
import 'vant/lib/index.css';
// 路由
import router from "@/router";
// 路由守卫
import '@/permission.js'
// 状态管理库
import store from "@/store/index.js"
import installPlugins from "@/plugins/index.js";
import directive from "@/directive/index.js";

// 用户配置
import customerConfig from '@/customerConfig.js';
import { useScreenDetect } from '@/composables/useScreenDetect.js';

const app = createApp(App)




installPlugins(app)
directive(app)
app.use(Antd)
app.use(customerConfig)
app.use(store)
app.use(router)

// 监听屏幕尺寸变化
// 启动监听
useScreenDetect()

app.mount("#app")